import dayjs from 'dayjs';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';

export interface IKpiData {
  id?: number;
  created?: string | null;
  odometer?: number | null;
  distanceTravelled?: number | null;
  speedAvg?: number | null;
  speedMax?: number | null;
  speedMin?: number | null;
  loadAvg?: number | null;
  loadMax?: number | null;
  loadMin?: number | null;
  absCount?: number | null;
  absMax?: number | null;
  rssCount?: number | null;
  rssMax?: number | null;
  breakCount?: number | null;
  breakMax?: number | null;
  breakCountDistanceHundred?: number | null;
  breakMaxOdometerHundred?: number | null;
  alertTotalCount?: number | null;
  alertSensorCount?: number | null;
  alertFenceCount?: number | null;
  alertIdentificationCount?: number | null;
  truckImplement?: ITruckImplement | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<IKpiData> = {};
